export default "__VITE_ASSET__By9ggelx__"